import { render } from "./approvals.vue?vue&type=template&id=3ae0ddb4&scoped=true"
import script from "./approvals.js?vue&type=script&lang=js&external"
export * from "./approvals.js?vue&type=script&lang=js&external"

import "./approvals.css?vue&type=style&index=0&id=3ae0ddb4&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae0ddb4"]])

export default __exports__